import { ICommonDataTableProps } from "./DataTable.types";
import { BaseDataTable } from "./BaseDataTable";
import React from "react";

export interface IStaticDataTableProps<TData extends Record<string, any>>
  extends ICommonDataTableProps<TData> {
  data: TData[] | null;
  isError?: boolean;
  isLoading?: boolean;
  isRefetching?: boolean;
}

export const StaticDataTable = <TData extends Record<string, any>>(
  props: IStaticDataTableProps<TData>,
) => {
  return <BaseDataTable<TData> {...props} />;
};
